module.exports = __webpack_public_path__ + "img/characteristic-title.17472788.png";